export default "__VITE_ASSET__za2Pg3bR__"